import type { ComplianceFlag } from '@/lib/contract';
import { cn } from '@/lib/cn';

const STATE_CLASS: Record<ComplianceFlag['state'], string> = {
  signed: 'bg-pass',
  pending: 'bg-warn',
  none: 'bg-dim'
};

const LABELS: Record<ComplianceFlag['key'], string> = {
  nda: 'NDA',
  msa: 'MSA',
  rate: 'RATE',
  trial: 'TRIAL'
};

/** The NDA / MSA / RATE / TRIAL dot row in the vendor roster. */
export function ComplianceDots({ compliance, className }: { compliance: ComplianceFlag[]; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      {compliance.map(flag => (
        <span key={flag.key} className="inline-flex items-center gap-1">
          <span className={cn('size-1.5 rounded-full', STATE_CLASS[flag.state])} />
          <span className="font-mono text-[9px] tracking-[0.1em] text-dim uppercase">{LABELS[flag.key]}</span>
        </span>
      ))}
    </span>
  );
}
